import { twMerge } from 'tailwind-merge';
import { accountingFormatNumber } from '@/utils';

export type ChangeOrderImpactType = 'days-and-months' | 'money' | 'days';

export function ImpactStats({
  label,
  value,
  type = 'days',
  className,
}: {
  label: string;
  value: number;
  type?: ChangeOrderImpactType;
  className?: string;
}) {
  const isPositive = value > 0;
  const isNegative = value > 0;
  const sign = isPositive ? '+' : isNegative ? '-' : '';

  const displayValue = () => {
    if (type === 'days-and-months') {
      const months = Math.floor(value / 30);
      return `${sign}${value} Days / ${sign}${months} Months`;
    }

    if (type === 'money') {
      return accountingFormatNumber({
        num: value,
        format: 'en-US',
        currency: 'USD',
      });
    }

    return `${sign}${value} Days`;
  };

  return (
    <p className={twMerge('font-medium text-base', className)}>
      {label}:{' '}
      <span className={twMerge(isPositive ? 'text-primaryColor-normal' : isNegative ? 'text-red-500' : 'text-inherit')}>
        {displayValue()}
      </span>
    </p>
  );
}
